export default "__VITE_ASSET__DLW6yz49__"